<div class="content-wrapper container-xxl p-0">
    <div class="content-body">
      <section id="ngx-datatable-kitchen-sink">
        <div class="card">
          <div class="card-header">
            <h4 class="card-title">{{ 'MENU.DASHBOARD.SECTORS' | translate }}</h4>
            <!-- <button class="btn btn-primary" (click)="addCoupon()">
              Add Employees
            </button> -->
          </div>
          <div class="card-body">
            <p class="card-text">{{ 'MENU.DASHBOARD.SECTORS_LIST' | translate }}</p>
          </div>
        </div>
  
        <div class="row d-flex justify-content-between">
          <div class="col-md-2 col-sm-12 mb-1 mb-md-0">
            <div class="form-group">
              <label for="itemsPerPage"  style="margin-right:6px !important">{{ 'MENU.DASHBOARD.show' | translate }}</label>
              <div class="d-flex align-items-center">
                <select
                  id="itemsPerPage"
                  class="form-control form-control-sm "
                  [(ngModel)]="itemsPerPage"
                >
                  <option value="10">10</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>
                <span class="mx-1">{{ 'MENU.DASHBOARD.entries' | translate }}</span>
              </div>
            </div>
          </div>
          <div class="col-md-6 col-sm-12">
            <div class="form-group">
              <label for="searchInput" class="mr-2">{{ 'MENU.DASHBOARD.search' | translate }}</label>
              <input
                id="searchInput"
                type="search"
                placeholder="{{ 'MENU.DASHBOARD.search' | translate }}"
                class="form-control form-control-sm"
                (keyup)="filterUpdate($event)"
                (search)="filterUpdate($event)"
              />
            </div> 
          </div>
        </div>
  
        <ngx-datatable 
        [rows]="pages"
        [rowHeight]="58"
        class="bootstrap core-bootstrap bg-white"
        [limit]="itemsPerPage"
        [columnMode]="ColumnMode.force"
        [headerHeight]="40"
        [footerHeight]="50"
        [scrollbarH]="true"
          [messages]="messages"

      >
      <!-- 🔢 Serial Number -->
<ngx-datatable-column
  name="{{ 'MENU.DASHBOARD.serial_number' | translate }}"
  [width]="120"
>
  <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex">
    {{ rowIndex + 1 }}
  </ng-template>
</ngx-datatable-column>

<!-- 🖼 Icon -->
<ngx-datatable-column
  name="{{ 'MENU.DASHBOARD.icon' | translate }}"
  [width]="150">
  <ng-template ngx-datatable-cell-template let-row="row">
    <ng-container *ngIf="row.icon; else noIcon">
      <img
        [src]="row.icon"
        alt="icon"
        width="40"
        height="40"
        style="object-fit: contain"
      />
    </ng-container>
    <ng-template #noIcon>
      <span class="text-muted">-</span>
    </ng-template>
  </ng-template>
</ngx-datatable-column>

<!-- 🏷 Title -->
<ngx-datatable-column
  name="{{ 'MENU.DASHBOARD.title' | translate }}"
  prop="title"
  [width]="250">
</ngx-datatable-column>


<!-- 📝 Description -->
<ngx-datatable-column
  name="{{ 'MENU.DASHBOARD.description' | translate }}"
  [width]="300">
  <ng-template ngx-datatable-cell-template let-row="row">
    {{ row.description ? (row.description | slice:0:40) + '...' : '-' }}
  </ng-template>
</ngx-datatable-column>


<!-- 🔢 Order -->
<!-- <ngx-datatable-column
  name="{{ 'MENU.DASHBOARD.order' | translate }}"
  prop="order"
  [width]="120">
</ngx-datatable-column> -->




<!-- ⚙️ Status -->
<!-- <ngx-datatable-column
  name="{{ 'MENU.DASHBOARD.status' | translate }}"
  [width]="150">
  <ng-template ngx-datatable-cell-template let-row="row">
    <span
      class="badge rounded-pill px-2 py-1"
      [ngClass]="row.is_active ? 'bg-success' : 'bg-danger'"
    >
      {{
        row.is_active
          ? ('MENU.DASHBOARD.active' | translate)
          : ('MENU.DASHBOARD.inactive' | translate)
      }}
    </span>
  </ng-template>
</ngx-datatable-column> -->


          <!-- Actions -->
<ngx-datatable-column name="{{ 'MENU.DASHBOARD.investor_actions' | translate }}" prop="actions" [flexGrow]="1" [sortable]="false">
  <ng-template ngx-datatable-cell-template let-row="row">
    <div class="d-flex align-items-center">
      <div ngbDropdown container="body" class="btn-group">
        <button
          ngbDropdownToggle
          type="button"
          class="btn btn-sm btn-icon dropdown-toggle hide-arrow"
          [id]="'dropdownActions_' + row.id"
        >
          <i data-feather="more-vertical"></i>
        </button>

        <div
          ngbDropdownMenu
          class="dropdown-menu dropdown-menu-right"
          [attr.aria-labelledby]="'dropdownActions_' + row.id"
        >

                       <!-- Edit Button -->
  <!-- <button
    class="dropdown-item text-primary w-100"
    ngbDropdownItem
    (click)="showTags(row.id)"
  >
    <i data-feather="eye" class="mr-50 mx-2"></i>
    {{ 'MENU.DASHBOARD.Show_Product_Tags' | translate }}
  </button> -->

  
  <!-- <button
  class="dropdown-item w-100"
  ngbDropdownItem
  (click)="viewDetails(row.id)"
>
  <i data-feather="eye" class="mr-50 mx-2"></i>
  {{ 'MENU.DASHBOARD.investor_details' | translate }}

</button> -->


     <!-- Edit Button -->
      <!-- <button
        class="dropdown-item w-100"
        ngbDropdownItem
        (click)="editProduct(row.id)"
      >
        <i data-feather="edit" class="mr-50 mx-2"></i>
        {{ 'MENU.DASHBOARD.investor_edit' | translate }}
      </button> -->

          <button
            class="dropdown-item text-danger w-100"
            ngbDropdownItem
  (click)="confirmDelete(row.id)"
          >
            <i data-feather="trash" class="mr-50 mx-2"></i>
             {{ 'MENU.DASHBOARD.investor_delete' | translate }}
          </button>
        </div>
      </div>
    </div>
  </ng-template>
</ngx-datatable-column>



      </ngx-datatable>
       
      </section>
    </div>
  </div>
  